var defaults = {
  close: '.js-modal-close',
  open: '.js-modal-open-' + name,
  openClass: 'modal--is-active',
  closingClass: 'modal--is-closing',
  bodyOpenClass: ['modal-open'],
  bodyOpenSolidClass: 'modal-open--solid',
  bodyClosingClass: 'modal-closing',
  closeOffContentClick: true
};
const Cookies = {
  // Get cookie by name
  get: function(name) {
    let cookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
    return cookie ? cookie.split('=')[1] : undefined;
  },

  // Set cookie with name, value, and optional expiration days
  set: function(name, value, days = 7) {
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },

  // Remove cookie by name
  remove: function(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
  },

  // Implementing noConflict method
  noConflict: function() {
    if (window.Cookies === this) {
      window.Cookies = undefined;
    }
    return this;
  }
};

function initDelayfunction(modal, data) {
  if (data.testMode === 'true') {
    return;
  }
  console.log({data})
  setTimeout(() => {
    const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
    if (newsletterAppeared) {
      const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
      // this.container.dispatchEvent(openReminder);
    } else {
      document.body.classList.add('modal-open')
      modal.classList.add(defaults.openClass)
      sessionStorage.setItem('newsletterAppeared', true);
    }
  }, data.secondsBeforeShow * 1000 )
  
 
}
function closePopup(data,cookieName) {
  // Remove a cookie in case it was set in test mode
  if (data.testMode === 'true') {
    Cookies.remove(cookieName, { path: '/' });
    return;
  }

  var expiry = data.daysBeforeReappear;
  var hasReminder = (data.hasReminder === 'true');
  var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');

  if (hasReminder && reminderAppeared) {
    Cookies.set(cookieName, 'opened', { path: '/', expires: expiry });
  } else if(!hasReminder) {
    Cookies.set(cookieName, 'opened', { path: '/', expires: expiry });
  }
}
function Newsletter(container) {
  if(!container) return;
  const sectionId = container.getAttribute('data-section-id')

  const cookieName = 'newsletter-'+sectionId
  const cookie = Cookies.get(cookieName)


  const modal = document.getElementById('NewsletterPopup-'+sectionId)

  const data = {
    secondsBeforeShow: container.dataset.delaySeconds,
    daysBeforeReappear: container.dataset.delayDays,
    hasReminder: container.dataset.hasReminder,
    testMode: container.dataset.testMode
  };
   // Prevent popup on Shopify robot challenge page
   if (window.location.pathname === '/challenge') {
    return;
  }

  // Prevent popup on password page
  if (window.location.pathname === '/password') {
    return;
  }

  initDelayfunction(modal, data)
  // document.body.classList.add('modal-open')
  // modal.classList.add(defaults.openClass)

  closePopup(data, cookieName)
  const closeBtn = document.querySelector('[js-newsletter-close-bnt]')
  closeBtn.addEventListener('click', function(evt) {
    modal.classList.remove(defaults.openClass)
    document.body.classList.remove('modal-open')
  })
  document.addEventListener('click', function(evt) {
    if(!evt.target.closest('.shop_by_brand__tab--title') && !evt.target.closest('.modal__centered')) {
      if(evt.target.closest('.modal') && modal.classList.contains('modal--is-active')) {
        modal.classList.remove(defaults.openClass)
        document.body.classList.remove('modal-open')
      }
    }
  })

}

Newsletter(document.querySelector('[js-newsletter-popup]'))


/*
  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
  
      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);
        
      console.log("newletter popup")
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.cookie) {
        this.initPopupDelay();
      }
  
      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            sessionStorage.setItem('newsletterAppeared', true);
          }
  
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');
  
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },
  
      onLoad: function () {
        this.modal.open();
      },
  
      onSelect: function () {
        this.modal.open();
      },
  
      onDeselect: function () {
        this.modal.close();
      },
  
      onBlockSelect: function () {
        this.modal.close();
      },
  
      onBlockDeselect: function () {
        this.modal.open();
      },
  
      onUnload: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();

 */
class NewsletterReminder extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('[data-close-button]');
    this.popupTrigger = this.querySelector('[data-message]');

    this.id = this.dataset.sectionId;
    this.newsletterId = `NewsletterPopup-${ this.id }`;
    this.cookie = Cookies.get(`newsletter-${this.id}`);
    this.cookieName = `newsletter-${this.id}`;
    this.secondsBeforeShow = this.dataset.delaySeconds;
    this.expiry = parseInt(this.dataset.delayDays);
    this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');
    console.log('newsletter reminder')
    this.init();
  }

  init() {
    document.addEventListener('shopify:block:select', (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.show(0, true)
      }
    });

    document.addEventListener('shopify:block:deselect', (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.hide();
      }
    });

    document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
    document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
    document.addEventListener(`newsletter:openReminder`, () => this.show(0));

    this.closeBtn.addEventListener('click', () => {
      this.hide();
      Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
    });

    this.popupTrigger.addEventListener('click', () => {
      const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
      this.dispatchEvent(reminderOpen);

      this.hide();
    });
  }

  show(time = this.secondsBeforeShow, forceOpen = false) {
    const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');

    if (!reminderAppeared) {
      setTimeout(() => {
        this.dataset.enabled = 'true';
        sessionStorage.setItem('reminderAppeared', true);
      }, time * 1000);
    }
  }

  hide() {
    this.dataset.enabled = 'false';
  }
}

customElements.define('newsletter-reminder', NewsletterReminder);
 
